import React, { Component, ReactNode } from 'react'
import { Alert, Button } from 'antd'
import styles from './styles.module.scss'

interface Props {
  children: ReactNode
  onClose: () => void
}

interface State {
  hasError: boolean
  error: Error | null
}

class AiDraftErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  handleClose = (): void => {
    this.setState({ hasError: false, error: null })
    this.props.onClose()
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className={styles.errorOnlyContainer}>
          <Alert
            message="An unexpected error occurred. Please try again or contact support."
            type="error"
            showIcon
            className={styles.errorAlert}
          />
          <div className={styles.errorActions}>
            <Button onClick={this.handleClose} type="primary" className={styles.errorButton}>
              Close
            </Button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default AiDraftErrorBoundary
